// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__vNnXh","label":"Completed_label__23i8y"};